import styles from 'style-guide/TypographyGuide.module.css';

interface SubHeadingOneProps {
  title: string;
  textColor?: string;
  subTitle?: string;
}

export const SubHeadingOne = ({ title, textColor, subTitle }: SubHeadingOneProps) => {
  return (
    <div style={{ color: textColor, display: 'inline-block' }}>
      <span className={`${styles.sub_heading_one}`}> {title} </span>
      <span style={{ fontSize: `.875rem` }}> {subTitle} </span>
    </div>
  );
};
